import React from 'react';
import { Box, Typography } from '@mui/material';

interface FixedAspectImageProps {
    imageUrl: string | null | undefined;
    alt?: string;
    aspectRatio?: number; // 幅/高さの比率
    maxWidth?: number | string;
    height?: number | string;
    placeholder?: React.ReactNode;
}

const FixedAspectImage: React.FC<FixedAspectImageProps> = ({
    imageUrl,
    alt = 'Image',
    aspectRatio = 4 / 3, // デフォルトは4:3の比率
    maxWidth = '100%',
    height = 240,
    placeholder
}) => {
    // 画像が存在するかどうか
    const hasImage = imageUrl != null && imageUrl !== '';
    // height(数値)とaspectRatioからボックス幅の上限を算出し、aspect-ratioで厳密に比率を維持
    const computedMaxWidth = typeof height === 'number' ? height * aspectRatio : maxWidth;

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: computedMaxWidth,
                aspectRatio: `${aspectRatio}`,
                overflow: 'hidden',
                backgroundColor: hasImage ? 'transparent' : 'grey.100',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 1,
            }}
        >
            {hasImage ? (
                <img
                    src={imageUrl!}
                    alt={alt}
                    style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: '100%',
                        maxHeight: '100%',
                    }}
                />
            ) : (
                placeholder || (
                    <Typography color="textSecondary">No Image</Typography>
                )
            )}
        </Box>
    );
};

export default FixedAspectImage;